import React from "react";

import { Grid, Stack } from "@mui/material";

import TransitionHeader from "../ui/TransitionHeader";
import TransitionHubSpotCard, {
  HubSpotLink,
} from "../ui/TransitionHubSpotCard";
import TransitionLinksCard, { LinkItem } from "../ui/TransitionLinksCard";

// Real data based on provided "How To Guides and Resources" table
const guideLinks: LinkItem[][] = [
  // Learning Management System + Training Calendar (combined in first card)
  [
    {
      title: "Learning Management System",
      subtitle:
        "Materials to assist new hires in navigating the systems and tools used at Farther",
      url: "http://lms.farther.com/",
    },
    {
      title: "Training Calendar",
      url: "https://calendar.google.com/calendar/embed?src=c_697a2f972a2e4dc3c5e3dd3b6bafc844361f124cc88ee393c0df7db92045865b%40group.calendar.google.com&ctz=America%2FNew_York",
    },
  ],
  // Individual guide cards
  [
    {
      title: "Zoom",
      subtitle: "Basic user guide for Zoom",
      url: "https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066777",
    },
  ],
  [
    {
      title: "Google My Business",
      subtitle: "Opting-in to Farther program to be present in Google Search",
      url: "https://www.notion.so/152d5585fd7680ada774cb2d75331597?pvs=21",
    },
  ],
  [
    {
      title: "Third-Party SMAs",
      subtitle: "Info on using third-party SMAs at Farther",
      url: "https://www.notion.so/Farther-Model-Marketplace-113d5585fd768062ad58d7c6f4d003d8?pvs=21",
    },
  ],
];

// Additional guides for right column below HubSpot
const rightColumnGuideLinks: LinkItem[][] = [
  [
    {
      title: "401(k)",
      subtitle:
        "Resources to streamline the process of building, managing, and marketing 401(k) plans for clients",
      url: "https://www.notion.so/149d5585fd7680eeb2f9ff7552bc079d?pvs=21",
    },
  ],
  [
    {
      title: "Resignation and Client Communications",
      subtitle:
        "Protocols and best practices for resignations and related client conversations",
      url: "https://drive.google.com/drive/folders/1JiCD1FuIrq2XrKJNlAim4YXPbLfe1Ds9",
    },
  ],
];

// HubSpot-specific links from the table for the special HubSpot card
const hubSpotCardLinks: HubSpotLink[] = [
  {
    title: "Link calendar",
    url: "https://docs.google.com/document/d/1OQz7Zb-6B-g03VaYbK7FzSrs1021dinokEMsA3S5DcI/edit?tab=t.0#heading=h.fbk3iqx322js",
  },
  {
    title: "Link Gmail",
    url: "https://ecosystem.hubspot.com/marketplace/apps/gmail",
  },
  {
    title: "Add contacts",
    url: "https://app.hubspot.com/academy/6481357/results?tools=SALES_CONTACTS",
  },
  {
    title: "Add deals",
    url: "https://docs.google.com/document/d/1Hw4AxrZQNw87HjZ89x-H1nqw-ybIltOHUBskJgiihac/edit?tab=t.0#heading=h.7hmas4lfbraz",
  },
];

const TransitionGuides: React.FC = () => {
  return (
    <div>
      <TransitionHeader title="How To Guides and Resources" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            {guideLinks.map((links, index) => (
              <TransitionLinksCard key={`guides-${index}`} links={links} />
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <TransitionHubSpotCard links={hubSpotCardLinks} />
            {rightColumnGuideLinks.map((links, index) => (
              <TransitionLinksCard key={`right-${index}`} links={links} />
            ))}
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default TransitionGuides;
